
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-twitter-ui-dialog',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './twitter-ui-dialog.component.html',
  styleUrl: './twitter-ui-dialog.component.css'
})
export class TwitterUiDialogComponent {
  constructor(public activeModal: NgbActiveModal) {}

  // State variables
  drawerOpen = true;  
 isTwitterDialogOpen = true;
  keyword = '';
  dayCount = 7;
  days = [1, 3, 5, 7, 10, 15, 30];

  searchOptions = [
    { name: 'All', icon: '🌐' },
    { name: 'Image', icon: '🖼️' },
    { name: 'Video', icon: '🎥' },
    { name: 'Text', icon: '📝' },
  ];
  selectedOption = this.searchOptions[0];

  closeDialog() {
    this.isTwitterDialogOpen = false;
    this.activeModal.dismiss();
  }

  selectOption(option: any) {
    this.selectedOption = option;
  }

  searchTweets() {
    if (!this.keyword) {
      alert('Please enter a keyword.');
      return;
    }
  }
}
